import i18n from "../../i18n";

export const autoRefreshSaved = localStorage.getItem("autoRefreshMonitoreos");
export const autoRefreshSavedValue =
    !autoRefreshSaved || autoRefreshSaved === "true";

export const autoRefreshTimeOptions = [
    {
        label: '5 minutos',
        value: 300000, // Valor por defecto
    },
    {
        label: '10 minutos',
        value: 600000,
    },
    {
        label: '30 minutos',
        value: 1800000,
    },
];

export const autoRefreshTimeSaved = localStorage.getItem(
    "autoRefreshTimeValue"
);
export const autoRefreshTimeSavedValue = autoRefreshTimeSaved
    ? parseInt(autoRefreshTimeSaved)
    : autoRefreshTimeOptions[0].value;
